import { createRouter, createWebHistory } from 'vue-router';
import selectInterface from '@/views/selectInterface.vue'; // Select Interface page
import FunnelData from '@/components/funnelData.vue'; // The data emulator page

const routes = [
  { path: '/', component: selectInterface },
  { path: '/public/:mode?', component: selectInterface, props: (route) => ({ mode: route.params.mode || 'funnel' }) }, // Defaults to 'funnel'
  { path: '/funnel-data', component: FunnelData },
  { path: "/:pathMatch(.*)*", redirect: "/" } // 👈 Catch-all, redirects unknown paths
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
